/**
 * Utilities for safe Next.js Router navigation.
 * Swallows only known cancellation errors to avoid unhandledrejection noise
 * while preserving real navigation failures.
 */

interface MaybeErrorLike {
  readonly name?: string;
  readonly message?: string;
  readonly cancelled?: boolean;
}

const isNavigationCancellationError = (err: unknown): boolean => {
  const e = err as MaybeErrorLike | undefined;
  const message = (e?.message || '').toLowerCase();
  if (e?.cancelled === true) return true;
  if (e?.name === 'AbortError') return true;
  if (message.includes('cancel rendering')) return true;
  if (message.includes('route') && message.includes('cancel')) return true;
  if (message.includes('aborted') || message.includes('abort')) return true;
  return false;
};

export const navigateSafely = async <T>(
  promise: Promise<T>
): Promise<T | undefined> => {
  try {
    return await promise;
  } catch (err) {
    if (isNavigationCancellationError(err)) {
      return undefined;
    }
    throw err;
  }
};
